import { render, staticRenderFns } from "./btn-up.vue?vue&type=template&id=b0e8bd48&scoped=true&"
import script from "./btn-up.vue?vue&type=script&lang=js&"
export * from "./btn-up.vue?vue&type=script&lang=js&"
import style0 from "./btn-up.vue?vue&type=style&index=0&id=b0e8bd48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e8bd48",
  null
  
)

export default component.exports